import styled from 'styled-components'

// The outer track of the progress bar
export const Track = styled.div`
  width: 100%;
  height: 12px;
  background-color: ${({ theme: { palette } }) => palette.background};
  border-radius: 9999px;
  overflow: hidden;
`

// The inner filled portion
export const Filler = styled.div<{ percentage: number; color: string }>`
  height: 100%;
  width: ${({ percentage }) => Math.max(0, Math.min(100, percentage))}%;
  background-color: ${({ color }) => color};
  border-radius: 9999px;
  transition: width 0.3s ease-in-out;
`
